import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { EditorButton } from './buttons';
import { Icon } from '../../icon';
import { Tooltip } from '../../tooltip';
export function List() {
    const { editor } = useCurrentEditor();
    if (!editor) {
        return null;
    }
    const disabled = !editor.isEditable;
    const isActive = !disabled && editor.isActive('bulletList');
    return (React.createElement(Tooltip, { content: "List", disabled: disabled },
        React.createElement(EditorButton, { StartIcon: React.createElement(Icon, { name: "list_outline" }), onClick: () => editor.chain().focus().toggleBulletList().run(), isActive: isActive, disabled: disabled || !editor.can().chain().focus().toggleBulletList().run() })));
}
